import React from 'react';
import { Typography } from '@mui/material';

const Settings = () => {
  return <Typography component={'h1'}>Setting</Typography>;
};

export default Settings;
